export const routeProps = {
  path: '/verify',
  exact: true,
};

export default () => routeProps;
